export const firstCharacterOfEachWord = (name: string): string[] => {
  if (!name.trim()) {
    return []
  }

  return name
    .trim()
    .split(/\s+/)
    .map(word => word[0])
}

export const getInitials = (original: string): string => {
  const MAX_INITIALS = 2

  if (!original.trim()) {
    return ''
  }

  // A string-starting 'The' shouldn't be used in the abbreviation,
  const excludeString = 'the '
  const startsWithThe = original.toLowerCase().startsWith(excludeString)
  // If "the " is not the only word in the string
  if (startsWithThe && original.length > excludeString.length) {
    original = original.substring(excludeString.length)
  }
  // TODO: remove interior short words like (of,a,for,and,by) too

  const initials = firstCharacterOfEachWord(original).filter(initial =>
    initial.match(/\p{L}|\p{N}/iu)
  )

  return initials.length > MAX_INITIALS ? initials[0] : initials.join('')
}
